import type { FC } from "react";
import { FKNode, type FKNodeProps } from "./formkit-node";
import noop from "lodash/noop";

type FKProcessNodeProps = Omit<FKNodeProps, "depth" | "context"> & {
  depth?: FKNodeProps["depth"];
  context?: FKNodeProps["context"];
};

export const FKProcessNode: FC<FKProcessNodeProps> = ({
  node,
  depth = 0,
  context,
}) => {
  return (
    <FKNode
      context={{
        showLocks: false,
        showOverrides: false,
        showClearable: false,
        clearFields: noop,
        isNodeVisible: () => true,
        ...context,
      }}
      depth={depth}
      node={node}
    />
  );
};
